import { ReadRequest } from "~/backendApis/foundation/ReadRequest"
import { FullCorporationAccountView } from "~/backendApis/viewModel"
import ApplicationApiError from "~/backendApis/foundation/ApplicationApiError"

interface Params {
  universalCorporationId: string
}

export class GetJoiningCorporationAccountReadRequest extends ReadRequest<FullCorporationAccountView> {
  private readonly params: Params

  constructor(params: Params) {
    super()
    this.params = params
  }

  public get(): Promise<FullCorporationAccountView | null> {
    return this.apiClient
      .get(this.makeEndpoint())
      .catch((e: ApplicationApiError) => {
        if (e.isNotFoundError()) {
          return null
        }
        throw e
      })
  }

  private makeEndpoint(): string {
    return `/corporation_account/corporation_member/${this.params.universalCorporationId}/current_corporation_account/show`
  }
}
